// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#img-hover[data-v-fe5ac670] {\n  opacity: 0.7;\n  transition: all 0.3s ease-in-out;\n}\n#hover-parent:hover > #img-hover[data-v-fe5ac670] {\n  opacity: 1;\n}\n.border-primary #img-hover[data-v-fe5ac670] {\n  opacity: 1;\n}\n.pop[data-v-fe5ac670] {\n  text-shadow: -1px -1px 0 var(--v-anti-base), 1px -1px 0 var(--v-anti-base),\n    -1px 1px 0 var(--v-anti-base), 1px 1px 0 var(--v-anti-base);\n}\n", ""]);
// Exports
module.exports = exports;
